const defaults = {
  alert: {
    __typename: 'Alert',
    open: false,
    message: null,
    type: null
  }
}

const resolvers = {
  Mutation: {
    setAlert: (_, { alert }, { cache }) => {
      const data = {
        alert: {
          __typename: 'Alert',
          open: true,
          ...alert
        }
      }
      cache.writeData({ data })
      return null
    },
    clearAlert: (_, args, { cache }) => {
      const data = defaults
      cache.writeData({ data })
      return null
    }
  }
}

export default { defaults, resolvers }
